import styled from 'styled-components';
import {
  PlaceholderCardList,
  PlaceholderSection
} from '../../../Placeholders/SectionPlaceholder/styled';
import { PlaceholderCardImg } from '../../../Placeholders/ItemCardPlaceholder/styled';
import { Breakpoints } from '../../../../styled/constants';

export const PlaceholderWrapper = styled.div`
  ${PlaceholderSection} {
    padding: 0;
  }

  ${PlaceholderCardList} {
    margin-top: 0;
    gap: 30px;
  }

  ${PlaceholderCardImg} {
    height: 200px;

    @media (min-width: ${Breakpoints.smallDesktop}px) {
      height: 140px;
    }
  }
`;
